import { NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Store } from '@ngrx/store';
import { AfterViewInit, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { AUTO_LOGIN } from './state/actions';
import { COMPANY_INFO, STAFF_NOTIFICATION_STATE, TENANTS_INFO } from './state/app.state';
import {
  BehaviorSubject,
  filter,
  map,
  mergeMap,
  Observable,
  Subscription,
} from 'rxjs';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { DOCUMENT } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { AuthSevices, SplashScreenStateService } from '@fitness-force/api';
import { Platform } from '@angular/cdk/platform';
import { AppState } from './state/app.state';
import { setTheme } from './state/app.reducer';
import { PrimeNG } from 'primeng/config';
import { TagStatsigService, ClientService, NotificationService } from '@fitness-force/api';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SidebarComponent, HeaderComponent } from '@fitness-force/core';
import { ToastModule } from 'primeng/toast';
import { CompanyInfoStoreInterface, StaffNotificationTopics, TENANTSINTERFACE } from '@fitness-force/models';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

@Component({
  selector: 'fitness-force-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    ConfirmDialogModule,
    ProgressSpinnerModule,
    SidebarComponent,
    HeaderComponent,
    ToastModule
  ]
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  title = 'UFP';
  public companyInfoDetail$: Observable<any> | any;
  subscription!: Subscription;
  public ip: string;
  selectedTenant: any;

  mainLoader = true;

  getAccessTenantList$: Observable<any> = new Observable();
  isTenantPresale = false;
  showStaffNotificationBanner = new BehaviorSubject<boolean>(false);
  showStaffPreferenceSidebar = new BehaviorSubject<boolean>(false);
  selectedStaffId = 0;
  currentUserDetails: any;
  isAdminLayout = new BehaviorSubject<boolean>(false);
  showNotification = new BehaviorSubject<boolean>(false);
  currentTheme: any = {
      name: 'Light Mode',
      icon: 'fa fa-sun',
      themeMode: 'light',
      selectedTheme: 'Lara',
      selectedColor: 'indigo',
      themes: [
        { themeName: 'Lara', colors:['indigo', 'emerald', 'zinc', 'green', 'lime', 'red', 'orange', 'amber', 'yellow', 'teal', 'sky', 'blue', 'violet', 'purple', 'fuchsia', 'pink', 'rose', 'slate', 'gray'] },
        { themeName: 'Aura', colors:['indigo', 'emerald', 'zinc', 'green', 'lime', 'red', 'orange', 'amber', 'yellow', 'teal', 'sky', 'blue', 'violet', 'purple', 'fuchsia', 'pink', 'rose', 'slate', 'gray'] },
        { themeName: 'Material', colors:['indigo', 'emerald', 'zinc', 'green', 'lime', 'red', 'orange', 'amber', 'yellow', 'teal', 'sky', 'blue', 'violet', 'purple', 'fuchsia', 'pink', 'rose', 'slate', 'gray'] },
        { themeName: 'Nora', colors:['indigo', 'emerald', 'zinc', 'green', 'lime', 'red', 'orange', 'amber', 'yellow', 'teal', 'sky', 'blue', 'violet', 'purple', 'fuchsia', 'pink', 'rose', 'slate', 'gray'] }
  ],
    };
  companyLogo = '';
  activeMenu!: string;
  themeLanguage!: string;
  loaderObservable$: Subscription | undefined;
  urlPath!: string;
  userId!: string;
  domainId!: string;
  companyUTCOffset!: string;
  statsigData: any;
  statsigError!: string;
  isMobile = false;
  showNav = false;
  Rtl = 'ltr';
  subscription$ = new Subscription();
  backDropsubscription$ = new Subscription();
  localsession: any[] = [];
  uuid!: string;
  StatsigEnabled = false;

  constructor(
    public store: Store<AppState>,
    private router: Router,
    private gtmService: GoogleTagManagerService,
    public translate: TranslateService,
    @Inject(DOCUMENT) private document: Document,
    private titleService: Title,
    private location: Location,
    public splashScreen: SplashScreenStateService,
    public platform: Platform,
    public authService: AuthSevices,
    public cdr : ChangeDetectorRef,
    private primeng: PrimeNG,
    private tagStatsigService: TagStatsigService,
    private clientService: ClientService,
    private notificationService: NotificationService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isAdminLayout.next(this.authService.isLoginedIn);
      }
    });
    this.store.select(state => state.theme.currentTheme)
      .subscribe(theme => {
        if (theme && theme.themeMode) {
          this.currentTheme = theme;
        }
      });

    // Load saved theme on startup
    const savedTheme = localStorage.getItem('selected-theme');
    if (savedTheme) {
      try {
        const parsedTheme = JSON.parse(savedTheme);
        this.currentTheme = parsedTheme;
        this.store.dispatch(setTheme({ theme: this.currentTheme }));
      } catch (e) {
        console.error('Error parsing saved theme:', e);
        this.store.dispatch(setTheme({ theme: this.currentTheme }));
      }
    }
    else{
      this.store.dispatch(setTheme({ theme: this.currentTheme }));
    }

    this.subscription$ = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.setLanguageDirection(event.lang);
      // Set translations for PrimeNG components
      this.translate.get('primeng').subscribe(res => {
        this.primeng.setTranslation(res);
      });
    });
  }

  setLanguageDirection(lang: string) {
    const htmlTag = this.document.getElementsByTagName('html')[0] as HTMLHtmlElement;
    const direction = lang === 'ar' ? 'rtl' : 'ltr';
    htmlTag.dir = direction;
    this.Rtl = direction;
  }

  ngOnInit(): void {
    this.componentInit();
  }

  componentInit() {
    this.translate.setDefaultLang('en');
    if(!window.location.hostname.startsWith('login.staff.')) {
      //this.store.dispatch({ type: 'FETCHED_COMPANY_DETAILS' });
      this.companyInfoDetail$ = this.store.select(COMPANY_INFO);
      this.companyInfoDetail$.subscribe({
        next: (companyDetails: any) => {
          if (
            companyDetails.err &&
            companyDetails.err.details &&
            companyDetails.err.details.status == 404
          ) {
            this.router.navigateByUrl('/company-not-found');
          }
        },
        error: (err: any) => {
          console.log(err);
        },
      });
      this.store.dispatch(AUTO_LOGIN());
      this.getAccessTenantList$ = this.store.select(TENANTS_INFO);
      this.getAccessTenantList$.subscribe((tenant: TENANTSINTERFACE) => {
        if (tenant?.selected_tenant?.id > 0) {
          this.selectedTenant = tenant.selected_tenant;
          this.isTenantPresale = tenant.selected_tenant.status.toLowerCase() === 'presales';
        }
      });
    }

    if(!window.location.hostname.startsWith('login.staff.')) {
    this.companyInfoDetail$.subscribe({
      next: (value: CompanyInfoStoreInterface) => {
        if (value && value.compDetails.primary_language) {
          if (value.selectedLang && this.translate?.getLangs()?.length > 0) {
            this.translate.use(value.selectedLang.LANG_CODE);
            //Setting primeng translations.
            this.translate
              .get('primeng')
              .subscribe((res) => this.primeng.setTranslation(res));
            return;
          }
          if (
            value.compDetails.supported_languages &&
            value.compDetails.primary_language
          ) {
            this.translate.addLangs(value.compDetails.supported_languages);
            this.translate.setDefaultLang(value.compDetails.primary_language);
            this.translate.use(value.compDetails.primary_language);
          }
        }
      },
    });
  }

    const navEndEvents = this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    );
    navEndEvents.subscribe({
      next: (event: any) => {
        const gtmTag = {
          event: 'page',
          pageName: event.url,
        };
        this.gtmService.pushTag(gtmTag);
        this.splashScreen.hideSplashScreen();
      },
    });

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.router.routerState.root),
        map((route) => {
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        mergeMap((route) => route.data)
      )
      .subscribe((data: any) => {
        const pageTitle = data.title || this.title;
        this.titleService.setTitle(pageTitle);
      });
  }

  ConfigureNotification(){
    this.showStaffNotificationBanner.next(false);
    this.showStaffPreferenceSidebar.next(true); 
  }

  SetHideNotification(value:boolean)
  {
    this.showStaffNotificationBanner.next(false);
    localStorage.setItem('HideStaffNotiifcationBanner_id_'+this.selectedStaffId,value.toString());
  }

  closeStaffNotificationBanner(event:any){
    this.showStaffPreferenceSidebar.next(false);
    this.store.select(STAFF_NOTIFICATION_STATE)
      .subscribe((responseData: any) => {
        const staffPref = responseData;
        if (
          this.authService && this.authService.isLoginedIn &&
          staffPref &&
          staffPref.subscribed_topics && staffPref.subscribed_topics.length > 0 &&
          staffPref.subscribed_topics.filter((o:StaffNotificationTopics) => o.isSubscribed).length === 0 &&
          (localStorage.getItem('HideStaffNotiifcationBanner_id_' + this.selectedStaffId) == null &&
            localStorage.getItem('HideStaffNotiifcationBanner_id_' + this.selectedStaffId) !== 'true')
        ) {
          this.showStaffNotificationBanner.next(true);
        }
        else{
          this.showStaffNotificationBanner.next(false);
        }
        
      });
  }


  setLanguage() {
    this.translate.setDefaultLang('en');
  }


  ngAfterViewInit(): void {
    console.log('ngAfterViewInit called');
  }



  ngOnDestroy(): void {
    if (this.subscription$) {
      this.subscription$.unsubscribe();
    }
    if (this.backDropsubscription$) {
      this.backDropsubscription$.unsubscribe();
    }
  }
}
